<template>
    <div class="bottom-banner3_ext" />
</template>
<script>
export default {};
</script>
